import { render, staticRenderFns } from "./BaseIframe.vue?vue&type=template&id=36353dc4&scoped=true&"
import script from "./BaseIframe.vue?vue&type=script&lang=js&"
export * from "./BaseIframe.vue?vue&type=script&lang=js&"
import style0 from "./BaseIframe.vue?vue&type=style&index=0&id=36353dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36353dc4",
  null
  
)

export default component.exports